import React, { useState } from "react";
import {
    Box,
    Button,
    Heading,
    Input,
    VStack,
    Text,
    useToast,
    Flex,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import StepHeader from "./StepHeader";

export default function Step1Name() {
    const [name, setName] = useState("");
    const toast = useToast();
    const navigate = useNavigate();

    const next = () => {
        if (!name.trim()) {
            toast({
                status: "error",
                title: "Vui lòng nhập tên background",
                position: "bottom-right"
            });
            return;
        }
        navigate("/design-background/create/step2", {
            state: { name: name.trim() },
        });
    };

    return (
        <Box p={6} w={"full"} display={"flex"} alignItems={"center"} flexDirection={"column"}>
            <StepHeader step={0} />
            <Box maxW="480px">
                <Heading size="md" mb={4}>
                    Bước 1: Nhập tên Banner
                </Heading>
                <VStack spacing={4} align="stretch" w={"full"}>
                    <Box>
                        <Flex mb={1} alignItems="center" gap="4px">
                            {"Tên Banner"}{" "}
                            <Text
                                color={"red"}
                                lineHeight={"15px"}
                            >
                                *
                            </Text>
                        </Flex>
                        <Input
                            w={"480px"}
                            placeholder="Ví dụ: Banner sale tháng 10..."
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Box>
                    <Button colorScheme="blue" onClick={next}>
                        Tiếp tục
                    </Button>
                </VStack>
            </Box>
        </Box>
    );
}
